import React, {PureComponent} from 'react';
import template from '../../templates/PageLayout/Sliders.rt';

export default class Sliders extends PureComponent {
  render() {
    return template.apply(this);
  }
}

